import { Box } from '@mui/system'
// import React from 'react'
// import FacebookIcon from '@mui/icons-material/Facebook';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import GitHubIcon from '@mui/icons-material/GitHub';
import { Link } from 'react-router-dom';

export default function SocialLinks(props: any) {
    const { displayType } = props;
    const links = [
        {
            src: "linkedin",
            url: "https://www.linkedin.com/in/bhrthkshr/",
            maticon: "LinkedInIcon",
            svgIcon: "linkedin"
        },
        // {
        //     src: "gitlab",
        //     url: "https://gitlab.com/bhrthkshr",
        //     maticon: "GitHubIcon",
        //     svgIcon: "gitlab"
        // },
        {
            src: "github",
            url: "https://github.com/bhrthkshr",
            maticon: "GitHubIcon",
            svgIcon: "github"
        }
        ,
        {
            src: "twitter",
            url: "https://twitter.com/Bhrthkshr",
            maticon: "TwitterIcon",
            svgIcon: "twitter"
        },
        {
            src: "instagram",
            url: "https://www.instagram.com/dev_bhrth/",
            maticon: "InstagramIcon",
            svgIcon: "instagram"
        }
    ]
    return (
        <div>
            {displayType === "horizontal" ? (
                <Box display="flex" flexDirection="row" p={0.5} className="ui-glassmoprhic-bg ui-border--r6">
                    {links.map((value, index) => (
                        <Box flex={1} p={0.5} key={index} display="flex" justifyContent="center">
                            <div className="ui-rect--28">
                                <img src={`/assets/logo/${value.svgIcon}.svg`} className="ui-image" alt="" />
                            </div>
                        </Box>
                    ))}
                </Box>
            ) :
                (<Box display="flex" flexDirection="column" className="ui-glassmoprhic-bg ui-border--r6">
                    {links.map((value, index) => (
                        <div key={index} className="social-card ui-cursor--pointer">
                            <Box p={1}>
                                <Link to={{ pathname: value.url }} target="_blank">
                                    <div className="ui-rect--28">
                                        <img src={`/assets/logo/${value.svgIcon}.svg`} className="ui-image" alt="" />
                                    </div>
                                </Link>
                            </Box>
                        </div>
                    ))}
                </Box>)
            }
        </div>
    )
}
